import { render, staticRenderFns } from "./EquipmentVesselCard.vue?vue&type=template&id=1ab36f0c&scoped=true&"
import script from "./EquipmentVesselCard.vue?vue&type=script&lang=js&"
export * from "./EquipmentVesselCard.vue?vue&type=script&lang=js&"
import style0 from "./EquipmentVesselCard.vue?vue&type=style&index=0&id=1ab36f0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab36f0c",
  null
  
)

export default component.exports